


class CookieHelper {
	setCookie =(cookieName, cookieValue, timeToExpire) => {
		var date = new Date((timeToExpire) * 1000);
		document.cookie = cookieName + " = " + cookieValue + "; expires = " +date.toGMTString()+"; path=/;";
	}

	getCookie =(cName) => {
		const name = cName + "=";
		const cDecoded = decodeURIComponent(document.cookie); //to be careful
		const cArr = cDecoded .split('; ');
		let res;
		cArr.forEach(val => {
			if (val.indexOf(name) === 0) res = val.substring(name.length);
		})
		return res;
	}
	
	setTokenCookie=(data) => {
		var tokenData = {};
		tokenData.token = data.token;
		tokenData.token_valid_till = data.token_valid_till;
		tokenData.uuid = data.uuid
		//tokenData.userAgent = uuidv5(window.navigator.userAgent);
		
		//console.log( "tokendata ", uuidv5(window.navigator.userAgent) );
		
		this.setCookie("mmev_obj", JSON.stringify(tokenData), data.token_valid_till);			
	}

	getToken=(data) => {
		let rawCookie = this.getCookie("mmev_obj");
		let retVal = '';
		if(typeof rawCookie != 'undefined') {
			let tokenObj = JSON.parse(rawCookie);
			if (tokenObj && tokenObj.token) {
				retVal = tokenObj.token;
			}
		}
	}
	
}
export default new CookieHelper();